import React from 'react';
import './CheckOut.css'

const CheckOut = () => {
 
    return (
        <div className='checkOut'>
            <h1>hello checkout</h1>
        </div>
    );
};

export default CheckOut;